import React from "react";

const CarouselLeftInactive = () => {
    return (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="15.5" fill="#fff" stroke="#DDD" />
            <path d="M18.5 10 12 16.5l6.5 6" stroke="#939393" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default CarouselLeftInactive;
